// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 新加的
import store from './store'
import '../reset.css'
import {CheckboxGroup, Calendar, Checkbox, Radio, Message, MessageBox, Button, Transfer, Pagination, Input, Menu, Submenu, MenuItem, MenuItemGroup, Dropdown, DropdownMenu, DropdownItem, Steps, Step, Table, TableColumn, Form, FormItem, Loading, Select, Option, Popover, DatePicker, Tabs, TabPane, Breadcrumb, BreadcrumbItem, Dialog, Notification, Autocomplete, Row, Col, Switch, Divider, Tooltip, Cascader} from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

// import ElementUI from 'element-ui'
import 'element-theme-chalk';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/css/reset-style-element.scss'
import './assets/icon/iconfont.css'
// import VueAMap from 'vue-amap'
import TargetSrc from './assets/js/environment'
import fetchData from './assets/js/fetchData'
import PriceUtil from './assets/js/priceUtil'
import dbClick from './assets/js/dbClick'
import Base64 from 'js-base64'
import VueLazyLoad from 'vue-lazyload'
// import FunctionalCalendar from 'vue-functional-calendar'
// import '../src/assets/js/timeValidate'
import '@/assets/icon'

import 'ant-design-vue/dist/antd.css'
import horizontalScroll from 'el-table-horizontal-scroll'
Vue.use(horizontalScroll)
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;  

import Print from 'vue-print-nb'; //引入打印功能
Vue.use(Print); //注册

// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '612562f45cb3bebb3ad07ec315c1a17d',
//   plugin: [
//     'AMap.Autocomplete', // 输入提示插件
//     'AMap.PlaceSearch', // POI搜索插件
//     'AMap.Scale', // 右下角缩略图插件 比例尺
//     'AMap.OverView', // 地图鹰眼插件
//     'AMap.ToolBar', // 地图工具条
//     'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
//     'AMap.PolyEditor', // 编辑 折线多，边形
//     'AMap.CircleEditor', // 圆形编辑器插件
//     'AMap.Geolocation' // 定位控件，用来获取和展示用户主机所在的经纬度位置
//   ],
//   uiVersion: '1.0'
// })
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.use(VueLazyLoad, {
  error: require('./assets/img/error.png'),
  loading: require('./assets/img/loading.gif')
})
// Vue.use(ElementUI)
Vue.use(Divider)
Vue.use(Radio)
Vue.use(Input)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dropdown)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Button)
// Vue.use(VueAMap)
Vue.use(Transfer)
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Loading)
Vue.use(Calendar)
Vue.use(Select)
Vue.use(Option)
Vue.use(Autocomplete)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(Cascader)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Col)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(dbClick)
// Vue.use(FunctionalCalendar, {
//   dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
// })

Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$http = fetchData // 绑定封装过的请求
Vue.prototype.$src = TargetSrc.targetSrc // 绑定图片路径
Vue.prototype.$imgprefix = TargetSrc.imgUrlPrefix // 绑定图片拼接url
Vue.prototype.$price = PriceUtil // 绑定money操作工具
Vue.prototype.$base = Base64.Base64 // 绑定base64
Vue.prototype.$ENVIRONMENT_API = 'https://ppapp.666yiyao.com'  // 测试环境接口地址
// Vue.prototype.$ENVIRONMENT_API = 'https://copd.666yiyao.com'  // 正式环境接口地址

Vue.config.productionTip = false
// const isDebugMode = process.env.NODE_ENV !== 'production'
// Vue.config.debug = isDebugMode
// Vue.config.devtools = isDebugMode
// Vue.config.productionTip = isDebugMode

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')

// })

// new Vue({
//   router,

//   render: h => h(App)
// }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js